/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

/* Our Own Stuff*/
import { LangService } from "src/app/core/services/lang.service";
import { GridService } from "src/app/shared/services/grid.service";
import { DataLoadService } from "src/app/shared/services/data-load.service";

@Component({
  selector: "app-hr-job-title-list-unit",
  templateUrl:
    "./../../../templates/forms/modals/hr-job-title-list.component.html"
})
export class HrJobTitleListComponent implements OnInit {
  /**
   * TO CHANGE:
   * selector, templateUrl,
   * apiUrl, apiParams, gridId, modalTitle, colObj,
   *
   * &
   *
   * Add to core.module dec[] & entry[]
   */
  //

  apiUrl = "FG_HR_COMM_JOBTITLE";
  apiParams = null;
  gridId = "HrJobTitleList";
  modalTitle = this.langService.langData.jobTitle;
  colObj = [];

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  grid: any;
  columnDefs = [];

  tableList = [];

  constructor(
    private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService
  ) {}

  ngOnInit() {
    this.setDefault();
  }

  setDefault() {
    this.colObj = [
      {
        headerName: this.langService.langData.jobTitle,
        field: "JOBTITLE_NO",
        sortable: true,
        resizable: true,
        hide: false
      }
    ];
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.initTable();
  }

  initTable() {
    if (this.apiParams) {
      this.dataService.load(this.apiUrl, this.apiParams).subscribe(results => {
        this.tableList = results.body;
      });
    } else {
      this.dataService.load(this.apiUrl).subscribe(results => {
        this.tableList = results.body;
      });
    }
  }

  itemClick(_item) {
    this.modalShow = false;
    this.submit.next(_item);
  }
}
